type QuizMapping = {
  subject: {
    "Nature & Outdoors": string[];
    "Urban & Architecture": string[];
    "People & Portraits": string[];
    "Everyday Objects": string[];
    "Abstract & Non-representational": string[];
  };
  style: {
    "Clean & Minimal": string[];
    "Bold & Expressive": string[];
    "Soft & Gentle": string[];
    "Graphic & Illustrative": string[];
    "Classic & Refined": string[];
  };
  mood: {
    "Calm & Peaceful": string[];
    "Energetic & Playful": string[];
    "Sophisticated & Elegant": string[];
    "Dreamy & Escapist": string[];
    "Striking & Impactful": string[];
  };
};

export const quizToTagMapping: QuizMapping = {
  // Step 1: What catches your eye most?
  subject: {
    "Nature & Outdoors": ["botanical", "landscapes", "beach", "animals"],
    "Urban & Architecture": ["architecture", "urban", "travel"],
    "People & Portraits": ["people", "nude"],
    "Everyday Objects": ["stilllife", "foodanddrink", "matchboxes"],
    "Abstract & Non-representational": ["abstract"],
  },

  // Step 2: What style speaks to you?
  style: {
    "Clean & Minimal": ["minimalist", "geometric", "lineart", "scandi"],
    "Bold & Expressive": ["bold", "electric", "popart", "surrealism"],
    "Soft & Gentle": ["softcolour", "cottagecore", "whimsical"],
    "Graphic & Illustrative": ["illustrative", "typographic", "swissdesign"],
    "Classic & Refined": ["blackandwhite", "monochromatic", "oriental"],
  },

  // Step 3: What mood are you looking to create?
  mood: {
    "Calm & Peaceful": ["softcolour", "minimalist", "scandi"],
    "Energetic & Playful": ["bold", "electric", "playful", "whimsical"],
    "Sophisticated & Elegant": ["blackandwhite", "monochromatic", "oriental"],
    "Dreamy & Escapist": ["escapist", "surrealism", "cottagecore"],
    "Striking & Impactful": ["popart", "brutalist", "geometric"],
  },
};
